import {MessageBaseView} from "../../MessageModel/view/MessageBaseView";

export class TodoCallEventView {
    id: number;
    dueDate: Date | null;
    type: number;
    level: number;
    memberId: number;
    memberFirstName: string;
    memberLastName: string;
    companyName: string;
    languageModelId: number;
    partnerRfpId: number | null;
    partnerRfpLanguageId: number | null;
    partnerRfpBusinessTypeTranslatedName: MessageBaseView | null;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.dueDate = data?.dueDate ? new Date(data.dueDate) : null;
        this.type = data?.type ?? 0;
        this.level = data?.level ?? 0;
        this.memberId = data?.memberId ?? 0;
        this.memberFirstName = data?.memberFirstName ?? "";
        this.memberLastName = data?.memberLastName ?? "";
        this.companyName = data?.companyName ?? "";
        this.languageModelId = data?.languageModelId ?? 0;
        this.partnerRfpId = data?.partnerRfpId ?? null;
        this.partnerRfpLanguageId = data?.partnerRfpLanguageId ?? null;
        this.partnerRfpBusinessTypeTranslatedName = data?.partnerRfpBusinessTypeTranslatedName ? new MessageBaseView(data.partnerRfpBusinessTypeTranslatedName) : null;
    }
}